import { Box, Card, CardHeader, CardBody, Heading, Text } from '@chakra-ui/react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { useNavigateToList } from '@/hooks/useNavigateToList'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { useThemeColors } from '@/hooks/useThemeColors'
import { BillingStatementForm } from '@/components/forms/BillingStatementForm'
import {
  billingStatementIdFromSearchParams,
  shippingLineIdFromSearchParams,
  shippingLineNameFromSearchParams,
  soaIdFromSearchParams,
} from '@/lib/navigation/financialStatementsSearchParams'

export default function EditBillingPage() {
  const colors = useThemeColors()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const params = useParams<{ shippingLineId: string; id: string }>()
  const paramsShippingLineId = params.shippingLineId
  const billingStatementId = params.id ? parseInt(params.id, 10) : undefined

  const shippingLineName = shippingLineNameFromSearchParams(searchParams)
  const finalShippingLineId =
    paramsShippingLineId ?? shippingLineIdFromSearchParams(searchParams)
  const navigateToList = useNavigateToList(
    finalShippingLineId
      ? `/shipping-lines/financial-statements/${finalShippingLineId}`
      : '/shipping-lines',
  )
  const finalSoaId = soaIdFromSearchParams(searchParams)
  const finalBillingStatementId =
    billingStatementId ?? billingStatementIdFromSearchParams(searchParams)

  const handleSuccess = () => {
    navigateToList()
  }

  const handleCancel = () => {
    navigateToList()
  }

  return (
    <AdminLayout>
      <Box p={4} h="100%" overflow="auto">
        <Card>
          <CardHeader>
            <Heading size="md" mb={1}>
              Edit Billing Statement
            </Heading>
            <Text fontSize="sm" color={colors.text}>
              Update Billing Statement details
            </Text>
          </CardHeader>
          <CardBody>
            <BillingStatementForm
              billingStatementId={finalBillingStatementId}
              soaId={finalSoaId}
              registeredName={shippingLineName}
              onSuccess={handleSuccess}
              onCancel={handleCancel}
            />
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}
